export default __webpack_public_path__ + "static/media/article-first.bbfe91a1.webp";